import {
  REQUEST_MAIN_EVENTS_NETWORK,
  RESPONSE_MAIN_EVENTS_NETWORK,
  FAILURE_MAIN_EVENTS_NETWORK,
  UPDATE_MAIN_EVENTS_NETWORK
} from "../../actions/types";
import { filterState } from "./constants";

const initialState = {
  isInitialScreen: true,
  isFetching: false,
  results: [],
  error: false,
  total: 0,
  isMyEvents: false,
  searchInput: "",
  filters: { ...filterState, activePage: 1, size: 25, from: 0 }
};

const setRequest = (state, action) => {
  let { isLoading, filters = { ...filterState }, isMyEvents, searchInput } = action.payload;
  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    results: [],
    total: 0,
    filters,
    isMyEvents,
    searchInput
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    results: []
  };
};

const setResponse = (state, action) => {
  let {
    results = [],
    total
  } = action.payload;

  return {
    ...state,
    isFetching: false,
    error: false,
    results: results,
    isInitialScreen: false,
    total
  };
};

const setUpdate = (state, action) => {
  let { filters = { ...filterState } } = action.payload;
  return {
    ...state,
    filters
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MAIN_EVENTS_NETWORK:
      return setRequest(state, action);

    case RESPONSE_MAIN_EVENTS_NETWORK:
      return setResponse(state, action);
      break;

    case FAILURE_MAIN_EVENTS_NETWORK:
      return setFailure(state, action);
      break;

    case UPDATE_MAIN_EVENTS_NETWORK:
      return setUpdate(state, action);

    default:
      return state;
      break;
  }
};
